export default {
    emailInfoHeading: 'Email Information',
    addtext: 'Add Another Email Address',
    switchErrorMsg: 'Please select atleast one Emailaddress  as Primary',
    emailErrorMsg: 'Please enter Primary Email Address',
    maxError: 'Only a maximum of 4 joint owners can be added.',
};
